define('modules/lp_integration/views/correodirect_popup',['require','exports','module','common/views/modal_view','ldsh!../templates/correodirect_popup'],function (require, exports, module) {
  "use strict";
  var ModalView = require("common/views/modal_view");
  module.exports = ModalView.extend({
    template: require("ldsh!../templates/correodirect_popup"),

    events: {
      "click .js-save": "save",
      "click .js-cancel": "hide"
    },

    helpers: function () {
      return {
        formFields: this.formFields,
        defaultFields: this.defaultFields,
        showSwitch: this.showSwitch
      };
    },

    defaultCorreoDirectFields: ["IP", "REFERER", "BirthYear", "BirthMonth", "BirthDay", "Sex", "Phone", "email", "ZipCode", "Fname", "Lname", "address", "City",
      "Profession", "Education", "Industry", "AreaIT", "VATNumber", "IDCard", "State", "Country", "Province", "TypeVia", "NumberAddress", "OperatorMobile", "Password"],

    uselessFormFields: ["http_user_agent", "timestamp", "url", "confirmation_url", "variant_name"],

    initialize: function (options) {
      this.formFields = options.formFields.reduce(function (all, stepFields) {
        return all.concat(stepFields.get("fields"));
      }, []);
      //this.formFields = _.difference(allFields, this.uselessFormFields);
      this.defaultFields = _.difference(options.defaultFields, this.uselessFormFields);
      this.showSwitch = !!options.showSwitch;
      this.onSave = options.onSave || _.identity;
      this.initializeI18n();
    },

    initializeI18n: function () {
      _.each(_.keys(this.i18n), function (key) {
        this.i18n[key] = $.i18n.t(this.i18n[key]);
      }, this);
    },

    i18n: {
      dropDownDefaultText: "integration.dropdownChooseOne",
    },

    save: function () {
      // get fields
      var idaf = this.$("#idaf").val().trim(),
          active = this.$("#active").is(":checked"),
          fieldAssociation = _.reduce(this.$(".js-fieldmapping"), function (result, item) {
            var pageField = $(item).data("field"),
                listField = $(item).find("select option:selected").attr("value");
            if (listField) {
              result[pageField.toString()] = listField;
            }
            return result;
          }, {});
      this.model.set("idaf", idaf);
      this.model.set("fields", fieldAssociation);
      if (this.model.isValid()) {
        this.model.set("active", !this.showSwitch || active);
        this.triggerMethod("save", this);
      } else {
        var errors = this.model.validationError;
        this.showErrors(errors);
      }
    },

    showErrors: function (errors) {
      _.each(errors, function (err) {
        //mark field as error
        this.$("#" + err.attribute).parent().addClass("has-error");
        this.$(".js-error-" + err.attribute).removeClass("hidden");
      }, this);
    },

    onRender: function () {
      this._renderLists();
      this.$el.i18n();
    },

    _renderLists: function () {
      var fieldLists = this.$(".js-correodirect-fields");

      fieldLists.each(_.bind(function (index, combo) {
        combo = this.$(combo);
        combo.empty();
        combo.append($("<option />").text(this.i18n.dropDownDefaultText));
        //add default fields
        _.each(this.defaultCorreoDirectFields, _.bind(function (name) {
          var item = $("<option />")
              .attr("value", name)
              .text(name);
          var mappedField = this.model.get("fields")[combo.data("field")];

          if (name === mappedField) {
            item.attr("selected", "selected");
          }
          combo.append(item);
        }, this));
      }, this));
    },
  });
});

